var map = {
	"./cgw-interfaces-1.2.pdf": "7ebc",
	"./dns-provisioning-2.1.1.pdf": "978d",
	"./domain-advertising-intro-1.0.pdf": "081a",
	"./errp-1.5.pdf": "bcca",
	"./idn-primer-1.0.pdf": "d606",
	"./irtp-1.1.pdf": "b719",
	"./template-examples-1.5.zip": "707c",
	"./templates-1.3.pdf": "55bd",
	"./wap-1.7.pdf": "9086",
	"./wdrp-1.5.pdf": "ca15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b7c";